module.exports = __webpack_public_path__ + "static/media/transaction-pending-icon-white.7455fda5.svg";